import type { Translate } from '@/shared/api/errors'
import type { CashDocument } from './cashdeskApi'
import { transferTypeName, type CashTransferType } from './transferTypeApi'

/** «TR-ABC-20261014-001 · Bank transfer · 4471-99» — tur va tashqi raqam faqat topshirishda bo'ladi */
export function transferDocumentText(
  document: CashDocument,
  types: readonly CashTransferType[] | undefined,
  t: Translate,
): string {
  return [
    document.number,
    document.transferType ? transferTypeName(document.transferType, types, t) : null,
    document.externalReference,
  ]
    .filter((part): part is string => Boolean(part))
    .join(' · ')
}
